import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../components/framework';
import Breadcrumb from '../components/framework/breadcrumb';
import PageHeader from '../components/framework/pages/page-header';
import SymptomList from '../components/symptom/list';
import Trans from '../components/translation/trans';
import useTranslation from '../hooks/use_translation';
import { getVariantByLanguage } from '../utils/helpers';

const SymptomGroup = ({ data, location }) => {
	const { language, t } = useTranslation('template_symptom_group');
	const group_id = data.group.group_id;
	const variant = getVariantByLanguage(language, data.group.group_variants);

	return (
		<Framework
			description={variant.seo_description}
			location={location}
			tags={variant.seo_keywords}
			title={variant.seo_title}
			tracking={{ content_group: 'SymptomGroup' }}
		>
			<section id="content">
				<div className="container px-0 mt-lg-3 mt-2">
					<nav aria-label="breadcrumb">
						<Breadcrumb
							className=""
							fact={true}
							links={[{ active: true, title: variant.title }]}
							symptom={true}
						/>
					</nav>
				</div>
			</section>
			<div className="container">
				<div className="mb-3 mb-lg-5">
					<PageHeader
						excerpt={<Trans defaults={variant.content} t={t} />}
						pageVariant="nested_page"
						title={variant.title}
					/>
				</div>
				<SymptomList include_groups={[group_id]} />
			</div>
		</Framework>
	);
};

SymptomGroup.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default SymptomGroup;

export const pageQuery = graphql`
	query SymptomGroupById($id: String!) {
		group(id: { eq: $id }) {
			id
			group_id
			group_variants {
				content
				excerpt
				language {
					code
				}
				seo_description
				seo_keywords
				seo_title
				slug
				title
			}
		}

		locales: allLocale {
			...translationFields
		}
	}
`;
